import { Routes } from '@angular/router';
import { StationSelectComponent } from './features/station-select/station-select.component';
import { StationHistoryComponent } from './features/station-history/station-history.component';
import { DatListComponent } from './features/dat-list/dat-list.component';
import { DatDetailComponent } from './features/dat-detail/dat-detail.component';

export const routes: Routes = [
  { path: '', component: StationSelectComponent },
  { path: 'gare/:stationId/historique', component: StationHistoryComponent },
  { path: 'gare/:stationId/dats', component: DatListComponent },
  { path: 'gare/:stationId/dats/:datId/detail', component: DatDetailComponent },
  { path: '**', redirectTo: '' },
];
